/* Stickidy Hızlı Seçim — koleksiyon sayfasında ölçü seç → kartlardan tepsiye at → tek tuşla sepete ekle.
   Kart verisi: snippets/stickidy-pick-card.liquid (data-stk-pick-data JSON + data-stk-pick-btn düğmesi).
   Bölüm: sections/stickidy-quick-pick.liquid ([data-stk-pick] kökü, ayarlar data-* ile).
   Ekstralar: 3 Al 2 Öde / kargo dürtüleri, bedava rozeti, öneriler, sürpriz 3, adet kısayolu, toplu ölçü,
   yapışkan mini ölçü çubuğu, ölçü kılavuzu, daha fazla yükle, sepette-var rozeti, liste paylaş, uçan görsel, olay takibi. */
(function () {
  'use strict';
  var root = document.querySelector('[data-stk-pick]:not([data-global])') || document.querySelector('[data-stk-pick]');
  if (!root || root.__stkPick) return;
  root.__stkPick = true;

  var KEY = 'stkPick.v1', TTL = 7 * 24 * 3600 * 1000;
  var ATTR = function (n, d) { var v = root.getAttribute(n); return v === null || v === '' ? d : v; };
  var BOOL = function (n, d) { var v = ATTR(n, null); return v === null ? d : v === 'true'; };
  var cfg = {
    addUrl: ATTR('data-cart-add-url', '/cart/add.js'),
    cartJs: ATTR('data-cart-js', '/cart.js'),
    cartPage: ATTR('data-cart-page', '/cart'),
    money: ATTR('data-money-format', '{{amount}}'),
    mode: ATTR('data-mode', 'quick'),
    defaultCm: parseFloat(String(ATTR('data-default-cm', '4')).replace(',', '.')) || 4,
    showBar: BOOL('data-show-bar', true),
    hideTheme: BOOL('data-hide-theme-button', true),
    bxgy: BOOL('data-bxgy', true),
    bxgyBuy: parseInt(ATTR('data-bxgy-buy', '3'), 10) || 3,
    bxgyTypes: ATTR('data-bxgy-types', 'Stickers').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean),
    ship: BOOL('data-ship', true),
    shipCents: Math.round((parseFloat(ATTR('data-ship-threshold', '0')) || 0) * 100),
    random: BOOL('data-random', true),
    recs: BOOL('data-recs', true),
    recsUrl: ATTR('data-recs-url', '/recommendations/products.json'),
    loadMore: BOOL('data-load-more', true),
    share: BOOL('data-share', true),
    sticky: BOOL('data-sticky', true),
    guide: BOOL('data-guide', true),
    track: BOOL('data-track', true),
    fly: BOOL('data-fly', true),
    global: BOOL('data-global', false)   // tema düzenindeki mini tepsi: kart yok, çubuk yok; yalnızca bekleyen seçimler
  };
  if (!/\.json(\?|$)/.test(cfg.recsUrl)) cfg.recsUrl = cfg.recsUrl.replace(/\/$/, '') + '.json';
  var T = {
    back_list: 'Listeye dön',
    global_hint: 'Seçtiğin stickerlar burada bekliyor.',
    bar_title: 'Hızlı Seçim',
    bar_sub: 'Seçili ölçü: {cm}', bar_hint: '',
    step1: 'Ölçüyü seç', step2: 'Kartta “{btn}”e dokun', step3: 'Alttaki tepsiden tek tuşla sepete ekle',
    random: '🎲 3 sürpriz ekle', random_done: '3 sürpriz sticker tepsiye eklendi 🎲', random_none: 'Bu ölçüde eklenecek sticker kalmadı',
    btn: 'Seç', btn_pick_size: 'Ölçü seç', cta: 'Hepsini Sepete Ekle', cta_short: 'Sepete Ekle',
    tray_count: '{n} sticker seçildi', tray_count_short: '{n} sticker', tray_review: 'Gözden geçir', tray_clear: 'Tepsiyi boşalt',
    tray_total: 'Toplam {total}', tray_savings: '{amount} bedava 🎉',
    added: '{t} · {cm} tepsiye eklendi', added_qty: '{t} · {cm} adet: {q}', removed: 'Tepsiden çıkarıldı',
    cart_ok: '{n} sticker sepete eklendi', cart_err: 'Sepete eklenemedi. Lütfen tekrar dene.',
    sheet_sub: 'Ölçü seç (uzun kenar)', sheet_foot: 'Ölçüye dokununca tepsiye eklenir.', sheet_qty: 'Adet', sold_out: 'Tükendi',
    bxgy_more: '3 Al 2 Öde: {n} sticker daha ekle, biri bedava olsun!', bxgy_done: '3 Al 2 Öde aktif: {free} sticker bedava 🎉', bxgy_have: '{free} bedava',
    bxgy_mini: '{rem}/{buy} · {n} daha → bedava', bxgy_mini_done: '{free} bedava 🎉',
    bxgy_nudge: '1 tane daha ekle, biri bedava olsun!', bxgy_won: '🎉 Biri bedava oldu!', free_badge: 'Bedava 🎉', free_part: '{n} bedava',
    ship_more: 'Ücretsiz kargoya {amount} kaldı', ship_done: 'Ücretsiz kargo kazandın 🚚', ship_nudge: '{n} sticker daha yeter',
    incart: 'Sepette ×{n}',
    recs_title: 'Bunlarla iyi gider', recs_add: '+ Ekle', recs_added: '✓ Eklendi ({n})',
    all_size: 'Tümünü şu ölçü yap:', all_size_done: '{n} sticker {cm} yapıldı', all_size_skip: '{k} üründe bu ölçü yok',
    share: 'Listeyi paylaş', share_title: 'Sticker listem', share_copied: 'Bağlantı kopyalandı', share_restored: '{n} sticker listeden tepsiye alındı',
    load_more: 'Daha fazla yükle', load_more_all: 'Tüm ürünler yüklendi', load_more_count: '{n} ürün gösteriliyor', loading: 'Yükleniyor…',
    guide_prefix: '≈ '
  };
  try { var sj = root.querySelector('[data-stk-pick-strings]'); if (sj) { var o = JSON.parse(sj.textContent || '{}'); for (var k in o) if (o[k] != null && o[k] !== '') T[k] = o[k]; } } catch (e) { /* varsayılanlar */ }
  var t = function (k, vars) { var s = T[k] || k; if (vars) for (var v in vars) s = s.split('{' + v + '}').join(vars[v]); return s; };

  var S = { cm: null, items: [], products: {}, sizes: [], open: false, cart: null, cartMap: {}, cartPid: {}, busy: false, recs: {}, recsPid: null, nextUrl: null, loadingMore: false, loaded: 0 };

  /* ------------------------------ yardımcılar ------------------------------ */
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var v = (cents || 0) / 100, f = cfg.money || '{{amount}}';
    function fmt(dec, ts, ds) { var p = v.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p.join(ds); }
    var out = f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(0, ',', '.');
        case 'amount_with_comma_separator': return fmt(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmt(0, ' ', ',');
        case 'amount_with_space_separator': return fmt(2, ' ', ',');
        default: return fmt(2, ',', '.');
      }
    });
    return out.replace(/<[^>]+>/g, '');
  }
  function cmOf(title, one) {
    if (!title || /^default title$/i.test(title)) return one;
    var nums = String(title).match(/\d+(?:[.,]\d+)?/g);
    if (!nums) return one;
    return Math.max.apply(null, nums.map(function (n) { return parseFloat(n.replace(',', '.')); }));
  }
  function cmLabel(cm) { return (cm % 1 ? cm.toFixed(1).replace('.', ',') : String(cm)) + ' cm'; }
  function nearest(list, cm) { if (!list.length) return null; var best = list[0]; list.forEach(function (x) { if (Math.abs(x - cm) < Math.abs(best - cm)) best = x; }); return best; }
  // Ölçü kuralı: seçili ölçü (varsayılan 4 cm) üründe varsa o; yoksa üründeki EN KÜÇÜK ölçü (1 cm hariç; yalnızca 1 cm varsa o).
  function pickCm(list, cm) { if (!list.length) return null; if (list.indexOf(cm) >= 0) return cm; var l2 = list.filter(function (x) { return x > 1; }); return Math.min.apply(null, l2.length ? l2 : list); }
  function count() { return S.items.reduce(function (n, it) { return n + it.qty; }, 0); }
  function total() { return S.items.reduce(function (n, it) { return n + it.p * it.qty; }, 0); }
  function vw() { return document.documentElement.clientWidth || window.innerWidth; }
  function reduced() { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function vibrate() { try { if (navigator.vibrate && vw() < 900) navigator.vibrate(12); } catch (e) { /* yoksay */ } }
  function oneCmFor(handle) { return /dollar|pantone/.test(String(handle || '')) ? 15 : 6; }
  var GUIDE = [[1, 'tırnak boyu'], [2, 'madeni para'], [4, 'posta pulu'], [5, 'kibrit kutusu'], [6, 'kredi kartı kısa kenarı'], [8, 'kredi kartı uzun kenarı'], [10, 'avuç içi'], [12, 'el boyu'], [15, 'telefon boyu'], [20, 'A5 kısa kenarı'], [22, 'A4 kısa kenarı'], [30, 'A4 uzun kenarı'], [40, 'laptop genişliği'], [50, 'yarım metre']];
  function guide(cm) { if (!cfg.guide) return ''; var best = GUIDE[0]; GUIDE.forEach(function (g) { if (Math.abs(g[0] - cm) < Math.abs(best[0] - cm)) best = g; }); return t('guide_prefix') + best[1]; }
  function track(name, data) {
    if (!cfg.track) return;
    var payload = Object.assign({ event: name }, data || {});
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) { /* yoksay */ }
    try { if (typeof window.gtag === 'function') window.gtag('event', name, data || {}); } catch (e) { /* yoksay */ }
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, data || {}); } catch (e) { /* yoksay */ }
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, data || {}); } catch (e) { /* yoksay */ }
  }
  function typicalPrice() {
    var ps = [];
    for (var id in S.products) S.products[id].v.forEach(function (v) { if (v.a && v.cm === S.cm) ps.push(v.p); });
    if (!ps.length) S.items.forEach(function (it) { ps.push(it.p); });
    if (!ps.length) return 1494;
    ps.sort(function (a, b) { return a - b; }); return ps[Math.floor(ps.length / 2)];
  }
  function isStickerType(ty) { ty = String(ty || '').toLowerCase(); return !ty || ty === 'stickers'; }

  /* ------------------------------ kalıcılık ------------------------------ */
  function load() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!d || !d.ts || Date.now() - d.ts > TTL) return;
      if (Array.isArray(d.items)) S.items = d.items.filter(function (it) { return it && it.vid && it.qty > 0; });
      if (d.cm) S.cm = d.cm;
      if (d.open) S.open = true;
      if (d.url) S.lastUrl = d.url;
    } catch (e) { /* yoksay */ }
  }
  function save() {
    try {
      var url = cfg.global ? (S.lastUrl || '') : (location.pathname + location.search);
      localStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), items: S.items, cm: S.cm, open: S.open, url: url }));
    } catch (e) { /* yoksay */ }
  }

  /* ------------------------------ kartlar ------------------------------ */
  function normalizeProduct(p) {
    p.one = p.one || oneCmFor(p.h);
    p.v = (p.v || []).map(function (v) { return { id: v.id, t: v.t, p: v.p, c: v.c || 0, a: !!v.a, cm: v.cm != null ? v.cm : cmOf(v.t, p.one) }; });
    return p;
  }
  function scan(ctx) {
    var found = 0;
    (ctx || document).querySelectorAll('[data-stk-pick-data]').forEach(function (sc) {
      if (sc.__stkDone) return; sc.__stkDone = true;
      var p; try { p = JSON.parse(sc.textContent); } catch (e) { return; }
      if (!p || !p.id || !Array.isArray(p.v)) return;
      normalizeProduct(p);
      S.products[p.id] = p; found++;
      var wrap = sc.parentNode, btn = wrap ? wrap.querySelector('[data-stk-pick-btn]') : null;
      if (!btn) return;
      if (cfg.hideTheme) wrap.querySelectorAll('modal-opener, product-form').forEach(function (x) { if (x.contains(btn)) return; x.hidden = true; x.style.display = 'none'; });
      var box = el('div', 'stk-pk-wrap');
      btn.parentNode.insertBefore(box, btn); box.appendChild(btn);
      btn.hidden = false; btn.style.display = ''; btn.__pid = p.id;
      btn.addEventListener('click', function (e) { e.preventDefault(); onPick(p, false, btn); });
      var avail = p.v.filter(function (v) { return v.a; });
      if (avail.length > 1 && cfg.mode === 'quick') {
        var more = el('button', 'stk-pk-more', '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>');
        more.type = 'button'; more.setAttribute('aria-label', t('btn_pick_size'));
        more.addEventListener('click', function (e) { e.preventDefault(); onPick(p, true, btn); });
        box.appendChild(more);
      }
      var card = btn.closest('.product-card'), holder = card ? (card.querySelector('.product-card__image-holder') || card.querySelector('.product-card__image')) : null;
      if (holder) {
        // Rozetler ürün görselinin üstünde: sol üst sepet (×N), sağ üst tepsi sayacı
        holder.classList.add('stk-pk-hasbadge');
        var ib = el('span', 'stk-pk-imgbadge stk-pk-imgbadge--cart', CART_SVG + '<b></b>'), tb = el('span', 'stk-pk-imgbadge stk-pk-imgbadge--tray');
        ib.hidden = true; tb.hidden = true;
        var tbc = card.querySelector('.badge__container'); if (tbc && tbc.children.length) ib.classList.add('stk-pk-imgbadge--low');
        holder.appendChild(ib); holder.appendChild(tb);
        p.__ib = ib; p.__tb = tb;
      } else {
        var incart = el('div', 'stk-pk-incart'); incart.hidden = true; box.parentNode.insertBefore(incart, box.nextSibling);
        p.__incart = incart;
      }
      p.__btn = btn;
    });
    if (found) { S.loaded = document.querySelectorAll('[data-stk-pick-data]').length; refreshSizes(); paintCards(); initLoadMore(); emitState(); }
  }
  function refreshSizes() {
    var set = {};
    for (var id in S.products) S.products[id].v.forEach(function (v) { if (v.a) set[v.cm] = true; });
    S.sizes = Object.keys(set).map(Number).sort(function (a, b) { return a - b; });
    if (!S.sizes.length) { renderBar(); return; }
    if (S.cm === null || S.sizes.indexOf(S.cm) < 0) S.cm = pickCm(S.sizes, S.cm !== null ? S.cm : cfg.defaultCm);
    renderBar();
  }
  function setLabel(lab, full, short) {
    lab.textContent = full;
    if (short !== full && lab.clientWidth > 0 && lab.scrollWidth > lab.clientWidth + 1) lab.textContent = short;
  }
  // Kart fiyatı SEÇ'in ekleyeceği ölçüye göre: "5,34 TL'den başlayan" (1 cm) yerine seçili ölçünün fiyatı + kendi üstü çizili fiyatı
  function paintPrice(p, btn, v) {
    if (p.__pr === undefined) { var cd = btn.closest('.product-card'); p.__pr = cd ? cd.querySelector('.price') : null; }
    if (!p.__pr) return;
    var reg = p.__pr.querySelector('.price__regular'), sale = p.__pr.querySelector('.price__sale');
    if (sale) { sale.textContent = money(v.p); if (reg) { var on = v.c && v.c > v.p; reg.textContent = on ? money(v.c) : ''; reg.style.display = on ? '' : 'none'; } }
    else if (reg) reg.textContent = money(v.p);
  }
  function paintCards() {
    for (var id in S.products) {
      var p = S.products[id], btn = p.__btn; if (!btn) continue;
      var q = S.items.filter(function (it) { return it.pid === p.id; }).reduce(function (n, it) { return n + it.qty; }, 0);
      var lab = btn.querySelector('.stk-pk-btn__label'), cnt = btn.querySelector('.stk-pk-btn__count');
      var avail = p.v.filter(function (v) { return v.a; });
      var want = pickCm(avail.map(function (v) { return v.cm; }), S.cm), hit = avail.filter(function (v) { return v.cm === want; })[0];
      btn.disabled = !avail.length;
      btn.classList.toggle('is-picked', q > 0);
      if (p.__tb) { cnt.hidden = true; p.__tb.hidden = q === 0; p.__tb.textContent = q; }
      else { cnt.hidden = q === 0; cnt.textContent = q; }
      if (!avail.length) setLabel(lab, t('sold_out'), t('sold_out'));
      else if (avail.length === 1) setLabel(lab, t('btn') + ' · ' + cmLabel(avail[0].cm), '+ ' + cmLabel(avail[0].cm));
      else if (cfg.mode === 'quick' && hit) { setLabel(lab, t('btn') + ' · ' + cmLabel(hit.cm), '+ ' + cmLabel(hit.cm)); paintPrice(p, btn, hit); }
      else setLabel(lab, t('btn') + ' · ' + t('btn_pick_size').toLowerCase(), t('btn_pick_size'));
      var inc = S.cartPid[p.id] || 0;
      if (p.__ib) { p.__ib.hidden = !inc; p.__ib.querySelector('b').textContent = '\u00d7' + inc; p.__ib.setAttribute('aria-label', inc ? t('incart', { n: inc }) : ''); }
      if (p.__incart) { p.__incart.hidden = !inc; p.__incart.textContent = inc ? t('incart', { n: inc }) : ''; }
    }
  }

  /* ------------------------------ ölçü çubuğu + mini ------------------------------ */
  var bar = null, mini = null, barIO = null;
  var CART_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg>';
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11V4a2 2 0 1 1 4 0v7"/><path d="M13 10.5V9a2 2 0 1 1 4 0v3"/><path d="M17 11.5a2 2 0 1 1 4 0V15a7 7 0 0 1-7 7h-1.5a7 7 0 0 1-5.6-2.8L3.4 14.7a1.8 1.8 0 0 1 2.7-2.3L9 15"/></svg>';
  function chipsInto(host, small) {
    host.innerHTML = '';
    S.sizes.forEach(function (cm) {
      var c = el('button', 'stk-pk__chip' + (cm === S.cm ? ' is-active' : ''), esc(cmLabel(cm)));
      c.type = 'button'; c.setAttribute('aria-pressed', cm === S.cm ? 'true' : 'false');
      if (!small && cfg.guide) c.title = guide(cm);
      c.addEventListener('click', function () { setCm(cm); });
      host.appendChild(c);
    });
  }
  // Tüm kartların ölçüsü; koleksiyon şeridi (stickidy-collection-chips) window.stkPick üzerinden kullanır
  function setCm(cm) { S.cm = cm; save(); renderBar(); paintCards(); track('stk_pick_size', { cm: cm }); emitState(); }
  function emitState() { try { document.dispatchEvent(new CustomEvent('stk:pick:state', { detail: { sizes: S.sizes.slice(), cm: S.cm } })); } catch (e) { /* yoksay */ } }
  window.stkPick = { get: function () { return { sizes: S.sizes.slice(), cm: S.cm }; }, setCm: setCm, label: cmLabel };
  function renderBar() {
    if (!cfg.showBar) return;
    if (!bar) { bar = el('div', 'stk-pk__bar'); root.appendChild(bar); watchBar(); }
    if (S.sizes.length < 2) { bar.hidden = true; if (mini) mini.classList.remove('is-on'); return; }
    bar.hidden = false;
    var g = guide(S.cm);
    bar.innerHTML = '<div class="stk-pk__head"><span class="stk-pk__icon" aria-hidden="true">' + ICON + '</span><div><div class="stk-pk__title">' + esc(t('bar_title')) + '</div><span class="stk-pk__sub">' + esc(t('bar_sub', { cm: '' })).replace(/\s*$/, '') + ' <b>' + esc(cmLabel(S.cm)) + '</b>' + (g ? ' <i>' + esc(g) + '</i>' : '') + '</span></div></div>' +
      '<div class="stk-pk__chips" role="group" aria-label="Ölçü"></div>' +
      (cfg.random ? '<button type="button" class="stk-pk__random">' + esc(t('random')) + '</button>' : '') +
      '<ol class="stk-pk__steps"><li><b>1</b>' + esc(t('step1')) + '</li><li><b>2</b>' + esc(t('step2', { btn: t('btn') })) + '</li><li><b>3</b>' + esc(t('step3')) + '</li></ol>' +
      (T.bar_hint ? '<p class="stk-pk__hint">' + esc(t('bar_hint')) + '</p>' : '');
    chipsInto(bar.querySelector('.stk-pk__chips'), false);
    var rb = bar.querySelector('.stk-pk__random'); if (rb) rb.addEventListener('click', addRandom);
    renderMini();
  }
  function stickyTop() {
    var hs = document.querySelectorAll('.shopify-section-header, #shopify-section-header, .section-header, header, .header');
    for (var i = 0; i < hs.length; i++) {
      var h = hs[i], cs = getComputedStyle(h);
      if (cs.position === 'sticky' || cs.position === 'fixed') { var r = h.getBoundingClientRect(); if (r.height > 0 && r.top <= 1) return Math.round(r.bottom); }
    }
    return 0;
  }
  function renderMini() {
    if (!cfg.sticky || !cfg.showBar) return;
    if (!mini) { mini = el('div', 'stk-pk-mini'); mini.setAttribute('aria-label', t('bar_title')); document.body.appendChild(mini); }
    if (S.sizes.length < 2) { mini.classList.remove('is-on'); return; }
    mini.innerHTML = '<span class="stk-pk-mini__icon" aria-hidden="true">' + ICON + '</span><div class="stk-pk__chips stk-pk-mini__chips"></div><button type="button" class="stk-pk-mini__count" hidden></button>';
    chipsInto(mini.querySelector('.stk-pk-mini__chips'), true);
    mini.querySelector('.stk-pk-mini__count').addEventListener('click', function () { setOpen(true); });
    paintMiniCount();
  }
  function paintMiniCount() {
    if (!mini) return; var cb = mini.querySelector('.stk-pk-mini__count'); if (!cb) return;
    var n = count(); cb.hidden = !n; cb.textContent = n;
  }
  function watchBar() {
    if (!cfg.sticky || !('IntersectionObserver' in window)) return;
    barIO = new IntersectionObserver(function (entries) {
      var e = entries[0]; if (!mini) return;
      var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (passed && S.sizes.length > 1 && !bar.hidden) { mini.style.top = stickyTop() + 'px'; mini.classList.add('is-on'); }
      else mini.classList.remove('is-on');
    }, { threshold: 0 });
    barIO.observe(bar);
  }

  /* ------------------------------ seçim ------------------------------ */
  function onPick(p, forceSheet, fromBtn) {
    var avail = p.v.filter(function (v) { return v.a; });
    if (!avail.length) { toast(t('sold_out'), true); return; }
    if (avail.length === 1) { addItem(p, avail[0], 1, { from: fromBtn }); return; }
    var want = pickCm(avail.map(function (v) { return v.cm; }), S.cm), hit = avail.filter(function (v) { return v.cm === want; })[0];
    if (!forceSheet && cfg.mode === 'quick' && hit) { addItem(p, hit, 1, { from: fromBtn }); return; }
    openSheet(p, null, fromBtn);
  }
  function addItem(p, v, qty, opt) {
    qty = qty || 1; opt = opt || {};
    var before = deal();
    var it = S.items.filter(function (x) { return x.vid === v.id; })[0];
    if (it) it.qty += qty; else S.items.push({ vid: v.id, pid: p.id, h: p.h, t: p.t, u: p.u, img: p.img, cm: v.cm, p: v.p, qty: qty, type: p.type || 'Stickers' });
    save(); paintCards(); renderTray(); paintMiniCount(); pulse(); vibrate();
    if (opt.from) fly(opt.from);
    if (S.open && tray) revealItem(v.id);
    track('stk_pick_add', { product: p.h, cm: v.cm, qty: qty, source: opt.source || 'card' });
    if (!opt.silent) {
      var msg = it ? t('added_qty', { t: p.t, cm: cmLabel(v.cm), q: it.qty }) : t('added', { t: p.t, cm: cmLabel(v.cm) });
      var after = deal();
      if (cfg.bxgy && after && after.buy) {
        if (after.rem === 0 && after.free > 0 && (!before || before.free < after.free)) msg = t('bxgy_won') + ' · ' + msg;
        else if (after.toNext === 1) msg += ' · ' + t('bxgy_nudge');
      }
      if (cfg.ship && after && after.shipLeft > 0 && after.shipLeft <= typicalPrice() * 1.5) msg += ' · ' + t('ship_more', { amount: money(after.shipLeft) });
      toast(msg);
    }
  }
  function changeQty(vid, d) {
    var it = S.items.filter(function (x) { return x.vid === vid; })[0]; if (!it) return;
    it.qty += d; if (it.qty <= 0) { S.items = S.items.filter(function (x) { return x.vid !== vid; }); track('stk_pick_remove', { product: it.h }); }
    save(); paintCards(); renderTray(); paintMiniCount();
  }
  function swapSize(it, v) {
    var same = S.items.filter(function (x) { return x.vid === v.id && x !== it; })[0];
    if (same) { same.qty += it.qty; S.items = S.items.filter(function (x) { return x !== it; }); }
    else { it.vid = v.id; it.cm = v.cm; it.p = v.p; }
    save(); paintCards(); renderTray();
  }
  function setAllSize(cm) {
    var n = 0, k = 0;
    S.items.slice().forEach(function (it) {
      var p = S.products[it.pid]; if (!p) { k++; return; }
      var v = p.v.filter(function (x) { return x.a && x.cm === cm; })[0];
      if (!v) { k++; return; }
      if (v.id !== it.vid) swapSize(it, v); n++;
    });
    var msg = t('all_size_done', { n: n, cm: cmLabel(cm) }); if (k) msg += ' · ' + t('all_size_skip', { k: k });
    toast(msg); track('stk_pick_all_size', { cm: cm, n: n });
  }
  function addRandom() {
    var pool = [], inTray = {};
    S.items.forEach(function (it) { inTray[it.pid] = true; });
    for (var id in S.products) {
      var p = S.products[id]; if (inTray[p.id]) continue;
      var avail = p.v.filter(function (v) { return v.a; }); if (!avail.length) continue;
      var wantCm = pickCm(avail.map(function (x) { return x.cm; }), S.cm), v = avail.length === 1 ? avail[0] : avail.filter(function (x) { return x.cm === wantCm; })[0];
      if (v) pool.push({ p: p, v: v });
    }
    if (!pool.length) { toast(t('random_none'), true); return; }
    for (var i = pool.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var tmp = pool[i]; pool[i] = pool[j]; pool[j] = tmp; }
    pool.slice(0, 3).forEach(function (x) { addItem(x.p, x.v, 1, { silent: true, source: 'random', from: x.p.__btn }); });
    toast(t('random_done')); track('stk_pick_random', { n: Math.min(3, pool.length) });
  }

  /* ------------------------------ ölçü penceresi ------------------------------ */
  var sheet = null;
  function openSheet(p, item, fromBtn) {
    closeSheet();
    var avail = p.v.filter(function (v) { return v.a; });
    var pre = item ? item.cm : (avail.filter(function (v) { return v.cm === S.cm; })[0] || {}).cm;
    if (pre == null) pre = pickCm(avail.map(function (v) { return v.cm; }), S.cm || cfg.defaultCm);
    var qty = 1;
    sheet = el('div', 'stk-pk-sheet');
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', p.t);
    sheet.innerHTML = '<div class="stk-pk-sheet__bg"></div><div class="stk-pk-sheet__box">' +
      '<div class="stk-pk-sheet__head"><div class="stk-pk-sheet__img"' + (p.img ? ' style="background-image:url(' + esc(p.img) + ')"' : '') + '></div>' +
      '<div class="stk-pk-sheet__title">' + esc(p.t) + '<span class="stk-pk-sheet__sub">' + esc(t('sheet_sub')) + '</span></div>' +
      '<button type="button" class="stk-pk-sheet__close" aria-label="Kapat">×</button></div>' +
      (item ? '' : '<div class="stk-pk-sheet__qty"><span>' + esc(t('sheet_qty')) + '</span><div class="stk-pk-seg" role="group">' + [1, 2, 3, 5].map(function (n) { return '<button type="button" class="stk-pk-seg__b' + (n === 1 ? ' is-on' : '') + '" data-q="' + n + '">×' + n + '</button>'; }).join('') + '</div></div>') +
      '<div class="stk-pk-sheet__grid"></div><p class="stk-pk-sheet__foot">' + esc(t('sheet_foot')) + '</p></div>';
    var grid = sheet.querySelector('.stk-pk-sheet__grid');
    p.v.forEach(function (v) {
      var g = guide(v.cm);
      var b = el('button', 'stk-pk-size' + (v.cm === pre ? ' is-default' : ''), '<b>' + esc(cmLabel(v.cm)) + '</b><small>' + (v.a ? esc(money(v.p)) : esc(t('sold_out'))) + '</small>' + (g ? '<em>' + esc(g) + '</em>' : ''));
      b.type = 'button'; b.disabled = !v.a;
      b.addEventListener('click', function () { if (item) swapSize(item, v); else addItem(p, v, qty, { from: fromBtn, source: 'sheet' }); closeSheet(); });
      grid.appendChild(b);
    });
    sheet.querySelectorAll('.stk-pk-seg__b').forEach(function (b) {
      b.addEventListener('click', function () { qty = parseInt(b.getAttribute('data-q'), 10) || 1; sheet.querySelectorAll('.stk-pk-seg__b').forEach(function (x) { x.classList.toggle('is-on', x === b); }); });
    });
    sheet.querySelector('.stk-pk-sheet__bg').addEventListener('click', closeSheet);
    sheet.querySelector('.stk-pk-sheet__close').addEventListener('click', closeSheet);
    document.body.appendChild(sheet);
    document.addEventListener('keydown', onEsc);
    var first = grid.querySelector('.is-default') || grid.querySelector('button:not(:disabled)'); if (first) try { first.focus({ preventScroll: true }); } catch (e) { /* yoksay */ }
  }
  function closeSheet() { if (sheet) { sheet.remove(); sheet = null; } document.removeEventListener('keydown', onEsc); }
  function onEsc(e) { if (e.key === 'Escape') closeSheet(); }

  /* ------------------------------ kampanya hesabı ------------------------------ */
  // Havuz = tepsi birimleri + sepetteki uygun birimler; en ucuz `free` birim bedava (Shopify BXGY mantığı).
  function deal() {
    if (!cfg.bxgy && !cfg.ship) return null;
    var pool = [];
    S.items.forEach(function (it) { it.freeQty = 0; for (var i = 0; i < it.qty; i++) pool.push({ p: it.p, it: it, src: 1 }); });
    if (S.cart && S.cart.items) S.cart.items.forEach(function (c) {
      var ty = String(c.product_type || '').toLowerCase(); if (!ty && cfg.bxgyTypes.indexOf('stickers') >= 0) ty = 'stickers';
      if (cfg.bxgyTypes.indexOf(ty) >= 0) for (var i = 0; i < c.quantity; i++) pool.push({ p: c.price, it: null, src: 0 });
    });
    // En ucuz birimler bedava; eşit fiyatta önce sepettekiler (zaten uygulanmış indirim tepsiye "kaymasın")
    pool.sort(function (a, b) { return a.p - b.p || a.src - b.src; });
    var buy = cfg.bxgy && cfg.bxgyBuy > 1 ? cfg.bxgyBuy : 0, tot = pool.length, free = buy ? Math.floor(tot / buy) : 0, rem = buy ? tot % buy : 0;
    var savings = 0, traySavings = 0;
    for (var i = 0; i < free; i++) { savings += pool[i].p; if (pool[i].it) { pool[i].it.freeQty++; traySavings += pool[i].p; } }
    var cartTotal = S.cart && S.cart.total_price ? S.cart.total_price : 0;
    var have = cartTotal + total() - traySavings, left = cfg.shipCents > 0 ? cfg.shipCents - have : -1;
    return { tot: tot, buy: buy, free: free, rem: rem, toNext: buy ? (rem === 0 ? (tot === 0 ? buy : 0) : buy - rem) : 0, savings: savings, traySavings: traySavings, have: have, shipLeft: left, shipDone: cfg.shipCents > 0 && left <= 0 };
  }

  /* ------------------------------ tepsi ------------------------------ */
  var tray = null, ui = {};
  function buildTray() {
    tray = el('div', 'stk-pk-tray');
    tray.setAttribute('role', 'region'); tray.setAttribute('aria-label', t('bar_title'));
    tray.innerHTML = '<div class="stk-pk-tray__in">' +
      '<div class="stk-pk-tray__row"><div class="stk-pk-tray__thumbs" data-tg></div>' +
      '<div class="stk-pk-tray__sum" data-tg><div class="stk-pk-tray__count"></div><div class="stk-pk-tray__total"></div></div>' +
      '<button type="button" class="stk-pk-tray__cta"></button>' +
      '<button type="button" class="stk-pk-tray__toggle" aria-expanded="false" aria-label="' + esc(t('tray_review')) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M18 15l-6-6-6 6"/></svg></button></div>' +
      '<div class="stk-pk-tray__panel" hidden><div class="stk-pk-tray__incent"></div><div class="stk-pk-tray__head"></div><ul class="stk-pk-tray__list"></ul><div class="stk-pk-tray__tools"></div><div class="stk-pk-recs" hidden></div><p class="stk-pk-tray__msg"></p>' +
      '<div class="stk-pk-tray__foot"><div class="stk-pk-tray__links"><button type="button" class="stk-pk-tray__clear"></button><button type="button" class="stk-pk-tray__share" hidden></button></div><button type="button" class="stk-pk-tray__cta stk-pk-tray__cta--foot"></button></div></div></div>';
    ui.thumbs = tray.querySelector('.stk-pk-tray__thumbs'); ui.count = tray.querySelector('.stk-pk-tray__count'); ui.total = tray.querySelector('.stk-pk-tray__total');
    ui.ctas = tray.querySelectorAll('.stk-pk-tray__cta'); ui.toggle = tray.querySelector('.stk-pk-tray__toggle'); ui.panel = tray.querySelector('.stk-pk-tray__panel');
    ui.inc = tray.querySelector('.stk-pk-tray__incent'); ui.head = tray.querySelector('.stk-pk-tray__head'); ui.list = tray.querySelector('.stk-pk-tray__list'); ui.tools = tray.querySelector('.stk-pk-tray__tools');
    ui.recs = tray.querySelector('.stk-pk-recs'); ui.msg = tray.querySelector('.stk-pk-tray__msg'); ui.clear = tray.querySelector('.stk-pk-tray__clear'); ui.share = tray.querySelector('.stk-pk-tray__share');
    tray.querySelectorAll('[data-tg]').forEach(function (x) { x.addEventListener('click', function () { setOpen(!S.open); }); });
    ui.toggle.addEventListener('click', function () { setOpen(!S.open); });
    ui.ctas.forEach(function (b) { b.addEventListener('click', addAll); });
    ui.clear.textContent = t('tray_clear');
    ui.clear.addEventListener('click', function () { S.items = []; save(); paintCards(); renderTray(); paintMiniCount(); toast(t('removed')); track('stk_pick_clear', {}); });
    if (cfg.share) { ui.share.hidden = false; ui.share.textContent = t('share'); ui.share.addEventListener('click', shareList); }
    if (cfg.global) {
      tray.classList.add('is-global');
      var back = el('a', 'stk-pk-tray__back', esc(t('back_list')) + ' →'); back.href = S.lastUrl || '/collections/all';
      tray.querySelector('.stk-pk-tray__links').appendChild(back);
      ui.head.insertAdjacentElement('afterend', el('p', 'stk-pk-tray__ghint', esc(t('global_hint'))));
    }
    // Üstteki yeşil tutamaç: tıkla → aç/kapat; kaydır → aç/kapat
    var handle = el('button', 'stk-pk-tray__handle', '<span></span>'); handle.type = 'button'; handle.setAttribute('aria-label', t('tray_review'));
    handle.addEventListener('click', function () { setOpen(!S.open); });
    tray.insertBefore(handle, tray.firstChild);
    // Parmak hareketi: tutamaç/şerit/başlıkta yukarı kaydır → aç, aşağı kaydır → kapat (sürüklerken tepsi takip eder)
    [handle, tray.querySelector('.stk-pk-tray__row'), ui.head, ui.inc].forEach(function (h) { if (h) swipeToggle(h); });
    document.body.appendChild(tray);
  }
  function swipeToggle(h) {
    var sy = 0, sx = 0, dy = 0, on = false, pid = null, last = 0;
    h.style.touchAction = 'none';
    h.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      var tb = e.target.closest('button, a, select, input'); if (tb && !tb.classList.contains('stk-pk-tray__handle')) return;
      sy = e.clientY; sx = e.clientX; dy = 0; on = true; pid = e.pointerId;
      try { h.setPointerCapture(pid); } catch (x) { /* yoksay */ }
    });
    h.addEventListener('pointermove', function (e) {
      if (!on) return;
      dy = e.clientY - sy; var dx = e.clientX - sx;
      if (Math.abs(dx) > Math.abs(dy) + 8) return;
      tray.style.transition = 'none';
      if (dy > 0) tray.style.transform = 'translateY(' + Math.min(dy, 160) + 'px)';
      else tray.style.transform = 'translateY(' + Math.max(dy, -60) * (S.open ? 0.15 : 0.35) + 'px)';
    });
    var end = function () {
      if (!on) return; on = false;
      try { h.releasePointerCapture(pid); } catch (x) { /* yoksay */ }
      tray.style.transition = ''; tray.style.transform = '';
      if (dy <= -36) { if (!S.open) { setOpen(true); vibrate(); } }
      else if (dy >= 36) { if (S.open) { setOpen(false); vibrate(); } }
      last = dy; dy = 0; setTimeout(function () { last = 0; }, 350);
    };
    h.addEventListener('pointerup', end); h.addEventListener('pointercancel', end);
    // sürükleme sonrası sentetik click ile yeniden toggle olmasın
    h.addEventListener('click', function (e) { if (Math.abs(last) >= 36) { e.stopPropagation(); e.preventDefault(); } }, true);
  }
  function setOpen(v) {
    S.open = !!v; save(); if (!tray) return;
    tray.classList.toggle('is-open', S.open); ui.panel.hidden = !S.open; ui.toggle.setAttribute('aria-expanded', S.open ? 'true' : 'false');
    var ch = tray.querySelector('.stk-pk-tray__chev'); if (ch) ch.textContent = S.open ? '▼' : '▲';
    if (S.open) { fetchCart(); loadRecs(); track('stk_pick_open', { n: count() }); } else renderRecs();
  }
  function renderTray() {
    if (!tray) buildTray();
    var n = count();
    if (!n) { tray.classList.remove('is-visible'); document.body.classList.remove('stk-pk-has-tray'); return; }
    tray.classList.add('is-visible'); document.body.classList.add('stk-pk-has-tray');
    tray.classList.toggle('is-open', S.open); ui.panel.hidden = !S.open; ui.toggle.setAttribute('aria-expanded', S.open ? 'true' : 'false');
    var d = deal();
    ui.thumbs.innerHTML = '';
    var w = vw(), maxT = w < 420 ? 2 : w < 577 ? 3 : 5;
    S.items.slice(0, maxT).forEach(function (it) { var dv = el('div', 'stk-pk-tray__thumb'); if (it.img) dv.style.backgroundImage = 'url(' + it.img + ')'; dv.title = it.t; ui.thumbs.appendChild(dv); });
    if (S.items.length > maxT) ui.thumbs.appendChild(el('div', 'stk-pk-tray__thumb stk-pk-tray__thumb--more', '+' + (S.items.length - maxT)));
    ui.count.textContent = t(w < 577 ? 'tray_count_short' : 'tray_count', { n: n });
    var mini = '';
    if (d && d.buy) mini = d.rem === 0 && d.free > 0 ? t('bxgy_mini_done', { free: d.free }) : t('bxgy_mini', { rem: d.rem, buy: d.buy, n: d.toNext });
    else if (d && cfg.ship && cfg.shipCents > 0) mini = d.shipDone ? t('ship_done') : t('ship_more', { amount: money(d.shipLeft) });
    ui.total.innerHTML = esc(money(total())) + (mini ? '<span class="stk-pk-tray__mini"> · ' + esc(mini) + '</span>' : '') + '<span class="stk-pk-tray__review"> · ' + esc(t('tray_review')) + '</span><span class="stk-pk-tray__chev" aria-hidden="true">' + (S.open ? '▼' : '▲') + '</span>';
    ui.ctas.forEach(function (b) { b.textContent = (b.classList.contains('stk-pk-tray__cta--foot') ? t('cta') : t('cta_short')) + ' (' + n + ')'; b.disabled = S.busy; });
    ui.head.innerHTML = '<b>' + esc(t('tray_total', { total: money(total()) })) + '</b>' + (d && d.traySavings > 0 ? '<span class="stk-pk-tray__save">' + esc(t('tray_savings', { amount: money(d.traySavings) })) + '</span>' : '');
    ui.list.innerHTML = '';
    S.items.forEach(function (it) {
      var li = el('li', 'stk-pk-item' + (it.freeQty ? ' is-free' : '')); li.setAttribute('data-vid', it.vid);
      var freeTxt = it.freeQty ? (it.freeQty >= it.qty ? t('free_badge') : t('free_part', { n: it.freeQty })) : '';
      li.innerHTML = '<div class="stk-pk-item__img"' + (it.img ? ' style="background-image:url(' + esc(it.img) + ')"' : '') + '></div>' +
        '<div class="stk-pk-item__t"><a class="stk-pk-item__name" href="' + esc(it.u || '#') + '">' + esc(it.t) + '</a>' +
        '<div class="stk-pk-item__meta"><button type="button" class="stk-pk-item__cm">' + esc(cmLabel(it.cm)) + '</button><span>' + esc(money(it.p * it.qty)) + '</span>' + (freeTxt ? '<span class="stk-pk-badge stk-pk-badge--free">' + esc(freeTxt) + '</span>' : '') + '</div></div>' +
        '<div class="stk-pk-qty"><button type="button" aria-label="Azalt">−</button><span>' + it.qty + '</span><button type="button" aria-label="Artır">+</button></div>' +
        '<button type="button" class="stk-pk-item__rm" aria-label="Kaldır">×</button>';
      var qb = li.querySelectorAll('.stk-pk-qty button');
      qb[0].addEventListener('click', function () { changeQty(it.vid, -1); });
      qb[1].addEventListener('click', function () { changeQty(it.vid, 1); });
      li.querySelector('.stk-pk-item__rm').addEventListener('click', function () { changeQty(it.vid, -it.qty); });
      li.querySelector('.stk-pk-item__cm').addEventListener('click', function () {
        var p = S.products[it.pid];
        if (!p) { p = { id: it.pid, t: it.t, img: it.img, v: [{ id: it.vid, t: cmLabel(it.cm), p: it.p, a: true, cm: it.cm }] }; }
        if (p.v.filter(function (v) { return v.a; }).length < 2) return;
        openSheet(p, it);
      });
      ui.list.appendChild(li);
    });
    renderTools();
    renderIncentives(d);
    renderRecs();
  }
  function renderTools() {
    var sizes = {}; S.sizes.forEach(function (c) { sizes[c] = true; }); S.items.forEach(function (it) { sizes[it.cm] = true; });
    var list = Object.keys(sizes).map(Number).sort(function (a, b) { return a - b; });
    if (list.length < 2 || S.items.length < 2) { ui.tools.innerHTML = ''; return; }
    ui.tools.innerHTML = '<label class="stk-pk-allsize"><span>' + esc(t('all_size')) + '</span><select><option value="">—</option>' + list.map(function (c) { return '<option value="' + c + '">' + esc(cmLabel(c)) + '</option>'; }).join('') + '</select></label>';
    ui.tools.querySelector('select').addEventListener('change', function () { var v = parseFloat(this.value); if (v) setAllSize(v); this.value = ''; });
  }
  // Açık panelde yeni/güncellenen satırı görünür alana getir ve kısa süre vurgula
  function revealItem(vid) {
    var li = ui.list ? ui.list.querySelector('[data-vid="' + vid + '"]') : null; if (!li) return;
    li.classList.add('is-new');
    try { li.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { li.scrollIntoView(); }
    setTimeout(function () { li.classList.remove('is-new'); }, 1400);
  }
  var bumpTimer = null;
  function pulse() { if (!tray) return; tray.classList.remove('is-bump'); void tray.offsetWidth; tray.classList.add('is-bump'); clearTimeout(bumpTimer); bumpTimer = setTimeout(function () { tray.classList.remove('is-bump'); }, 400); }
  function fly(fromBtn) {
    if (!cfg.fly || reduced() || !tray || !fromBtn) return;
    try {
      var card = fromBtn.closest('.product-card') || fromBtn.parentNode, img = card ? card.querySelector('img') : null; if (!img) return;
      var a = img.getBoundingClientRect(), b = ui.thumbs.getBoundingClientRect(); if (!a.width || !b.width) return;
      var size = Math.min(72, a.width), ghost = el('div', 'stk-pk-fly');
      ghost.style.cssText = 'left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;background-image:url(' + (img.currentSrc || img.src) + ')';
      document.body.appendChild(ghost);
      var dx = (b.left + 24) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
      var anim = ghost.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.25)', opacity: .35 }], { duration: 520, easing: 'cubic-bezier(.2,.8,.2,1)' });
      anim.onfinish = function () { ghost.remove(); }; setTimeout(function () { if (ghost.parentNode) ghost.remove(); }, 800);
    } catch (e) { /* yoksay */ }
  }

  /* ------------------------------ teşvikler ------------------------------ */
  function renderIncentives(d) {
    if (!tray) return;
    d = d || deal();
    ui.inc.innerHTML = '';
    if (!d) return;
    if (d.buy) {
      var done = d.tot > 0 && d.rem === 0, txt, pct;
      if (done) { txt = t('bxgy_done', { free: d.free }); pct = 100; }
      else { txt = t('bxgy_more', { n: d.toNext }); pct = Math.round(d.rem / d.buy * 100); if (d.free > 0) txt += ' · ' + t('bxgy_have', { free: d.free }); }
      ui.inc.appendChild(incRow(txt, pct, done));
    }
    if (cfg.ship && cfg.shipCents > 0) {
      var txt2 = d.shipDone ? t('ship_done') : t('ship_more', { amount: money(d.shipLeft) });
      if (!d.shipDone) { var need = Math.max(1, Math.ceil(d.shipLeft / typicalPrice())); if (need <= 3) txt2 += ' · ' + t('ship_nudge', { n: need }); }
      ui.inc.appendChild(incRow(txt2, Math.min(100, Math.round(d.have / cfg.shipCents * 100)), d.shipDone));
    }
  }
  function incRow(text, pct, done) {
    var d = el('div', 'stk-pk-inc' + (done ? ' is-done' : ''));
    d.innerHTML = '<div class="stk-pk-inc__text"><b>' + esc(text) + '</b></div><div class="stk-pk-inc__bar"><div class="stk-pk-inc__fill" style="transform:scaleX(' + (Math.max(0, Math.min(100, pct)) / 100) + ')"></div></div>';
    return d;
  }

  /* ------------------------------ sepet ------------------------------ */
  function cartEl() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
  function fetchCart() {
    return fetch(cfg.cartJs, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        S.cart = j; S.cartMap = {}; S.cartPid = {};
        (j.items || []).forEach(function (c) { S.cartMap[c.variant_id] = (S.cartMap[c.variant_id] || 0) + c.quantity; S.cartPid[c.product_id] = (S.cartPid[c.product_id] || 0) + c.quantity; });
        paintCards(); if (count()) renderTray(); return j;
      })
      .catch(function () { /* çevrimdışı */ });
  }
  function addAll() {
    if (S.busy || !S.items.length) return;
    S.busy = true; ui.msg.textContent = ''; ui.ctas.forEach(function (b) { b.disabled = true; b.classList.add('is-busy'); });
    var ce = cartEl(), sections = null;
    try { if (ce && typeof ce.getSectionsToRender === 'function') { sections = ce.getSectionsToRender().map(function (s) { return s.id; }).join(','); if (typeof ce.setActiveElement === 'function') ce.setActiveElement(document.activeElement); } } catch (e) { sections = null; }
    var body = { items: S.items.map(function (it) { return { id: it.vid, quantity: it.qty }; }) };
    if (sections) { body.sections = sections; body.sections_url = location.pathname; }
    var n = count(), tot = total();
    fetch(cfg.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'cart'); return j; }); })
      .then(function (json) {
        S.busy = false; ui.ctas.forEach(function (b) { b.classList.remove('is-busy'); });
        var handled = false;
        try {
          if (ce && typeof ce.renderContents === 'function' && json && json.sections) {
            ce.classList.remove('is-empty'); var inner = ce.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
            ce.renderContents(json); handled = true;
          }
        } catch (e) { handled = false; }
        try { var EVS = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS; if (typeof window.publish === 'function' && EVS && EVS.cartUpdate) window.publish(EVS.cartUpdate, { source: 'product-form' }); } catch (e) { /* yoksay */ }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        track('stk_pick_add_all', { n: n, value: tot / 100, currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY' });
        S.items = []; S.open = false; save(); paintCards(); renderTray(); paintMiniCount();
        toast(t('cart_ok', { n: n }));
        fetchCart();
        if (!handled && !root.hasAttribute('data-no-redirect')) window.location.href = cfg.cartPage;
      })
      .catch(function (err) {
        S.busy = false; ui.ctas.forEach(function (b) { b.disabled = false; b.classList.remove('is-busy'); });
        ui.msg.textContent = t('cart_err') + (err && err.message ? ' (' + err.message + ')' : '');
        setOpen(true); toast(t('cart_err'), true);
      });
  }

  /* ------------------------------ öneriler ------------------------------ */
  function mapApiProduct(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img && img.indexOf('width=') < 0) img += (img.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
    var url = String(p.url || ('/products/' + p.handle)).split('?')[0];
    return normalizeProduct({ id: p.id, h: p.handle, t: p.title, u: url, img: img, type: p.type || p.product_type || '', v: (p.variants || []).map(function (v) { return { id: v.id, t: v.title, p: v.price, a: v.available !== false }; }) });
  }
  function loadRecs() {
    if (!cfg.recs || !S.items.length || !ui.recs) return;
    var pid = S.items[S.items.length - 1].pid; if (!pid) return;
    if (S.recs[pid]) { S.recsPid = pid; renderRecs(); return; }
    var url = cfg.recsUrl + (cfg.recsUrl.indexOf('?') >= 0 ? '&' : '?') + 'product_id=' + encodeURIComponent(pid) + '&limit=8&intent=related';
    fetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { S.recs[pid] = (j.products || []).filter(function (p) { return p.available !== false && isStickerType(p.type || p.product_type); }).map(mapApiProduct); S.recsPid = pid; renderRecs(); })
      .catch(function () { S.recs[pid] = []; });
  }
  function renderRecs() {
    if (!ui.recs || !cfg.recs) return;
    var list = (S.recsPid && S.recs[S.recsPid]) || [];
    var inTray = {}; S.items.forEach(function (it) { inTray[it.pid] = (inTray[it.pid] || 0) + it.qty; });
    // İlk açılışta tepside olanları ele; sonradan eklenenler yerinde kalsın (şerit kaymasın)
    if (!ui.recs.__shown) ui.recs.__shown = {};
    list = list.filter(function (p) { return p.v.some(function (v) { return v.a; }) && (ui.recs.__shown[p.id] || !inTray[p.id]); }).slice(0, 6);
    if (!list.length || !S.open) { ui.recs.hidden = true; return; }
    list.forEach(function (p) { ui.recs.__shown[p.id] = true; });
    ui.recs.hidden = false;
    ui.recs.innerHTML = '<div class="stk-pk-recs__title">' + esc(t('recs_title')) + '</div><div class="stk-pk-recs__row"></div>';
    var row = ui.recs.querySelector('.stk-pk-recs__row');
    list.forEach(function (p) {
      var avail = p.v.filter(function (v) { return v.a; }), hit = avail.filter(function (v) { return v.cm === S.cm; })[0] || (avail.length === 1 ? avail[0] : null);
      var have = inTray[p.id] || 0;
      var c = el('div', 'stk-pk-rec' + (have ? ' is-added' : ''));
      c.innerHTML = '<div class="stk-pk-rec__img"' + (p.img ? ' style="background-image:url(' + esc(p.img) + ')"' : '') + '></div><div class="stk-pk-rec__t">' + esc(p.t) + '</div><div class="stk-pk-rec__p">' + esc(hit ? cmLabel(hit.cm) + ' · ' + money(hit.p) : t('btn_pick_size')) + '</div><button type="button" class="stk-pk-rec__add">' + esc(have ? t('recs_added', { n: have }) : t('recs_add')) + '</button>';
      c.querySelector('.stk-pk-rec__add').addEventListener('click', function () {
        S.products[p.id] = S.products[p.id] || p;
        if (hit) addItem(p, hit, 1, { source: 'recs' }); else openSheet(p, null);
        track('stk_pick_rec_add', { product: p.h });
      });
      row.appendChild(c);
    });
  }

  /* ------------------------------ daha fazla yükle ------------------------------ */
  var moreBox = null, moreIO = null;
  function initLoadMore() {
    if (!cfg.loadMore) return;
    var container = document.getElementById('ProductGridContainer'), grid = document.getElementById('product-grid');
    if (!grid || !container) return;
    if (moreBox && container.contains(moreBox)) return; // aynı kapsayıcı, hazır
    var pag = container.querySelector('.pagination__container');
    var nextHref = nextHrefFrom(document, container);
    if (!nextHref) return;
    S.nextUrl = nextHref;
    if (pag) pag.hidden = true;
    moreBox = el('div', 'stk-pk-loadmore');
    moreBox.innerHTML = '<button type="button" class="stk-pk-loadmore__btn">' + esc(t('load_more')) + '</button><div class="stk-pk-loadmore__info"></div>';
    container.appendChild(moreBox);
    moreBox.querySelector('button').addEventListener('click', loadMore);
    updateMoreInfo();
    if ('IntersectionObserver' in window) {
      if (moreIO) moreIO.disconnect();
      moreIO = new IntersectionObserver(function (en) { if (en[0].isIntersecting && S.nextUrl && !S.loadingMore) loadMore(); }, { rootMargin: '600px 0px' });
      moreIO.observe(moreBox);
    }
  }
  // Sonraki sayfa: <link rel=next> (tema üretmiyor) → sayfalamadaki "Sonraki" oku → geçerli sayfadan sonraki bağlantı
  function nextHrefFrom(doc, scope) {
    var n = doc.querySelector('link[rel=next]'); if (n && n.getAttribute('href')) return n.getAttribute('href');
    var pag = (scope || doc).querySelector('.pagination__container') || doc.querySelector('.pagination__container');
    if (!pag) return null;
    var a = pag.querySelector('a.pagination__item--next[href]'); if (a) return a.getAttribute('href');
    var cur = pag.querySelector('.pagination__item--current'); var li = cur ? cur.closest('li') : null;
    a = li && li.nextElementSibling ? li.nextElementSibling.querySelector('a[href]') : null;
    return a ? a.getAttribute('href') : null;
  }
  function updateMoreInfo() {
    if (!moreBox) return;
    moreBox.querySelector('.stk-pk-loadmore__info').textContent = t('load_more_count', { n: document.querySelectorAll('#product-grid .product-card').length });
  }
  function loadMore() {
    if (!S.nextUrl || S.loadingMore) return;
    S.loadingMore = true; var btn = moreBox.querySelector('button'); btn.disabled = true; btn.textContent = t('loading');
    var url = S.nextUrl;
    fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById('product-grid'), ng = doc.getElementById('product-grid');
        if (grid && ng) Array.prototype.slice.call(ng.children).forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
        var added = ng ? ng.children.length : 0;
        S.nextUrl = added ? nextHrefFrom(doc) : null;
        if (S.nextUrl === url) S.nextUrl = null; // döngü koruması
        S.loadingMore = false; btn.disabled = false; btn.textContent = t('load_more');
        if (!S.nextUrl) { btn.hidden = true; moreBox.querySelector('.stk-pk-loadmore__info').textContent = t('load_more_all'); if (moreIO) moreIO.disconnect(); }
        else updateMoreInfo();
        scan(document); recycleImgs(); track('stk_pick_load_more', { url: url });
      })
      .catch(function () { S.loadingMore = false; btn.disabled = false; btn.textContent = t('load_more'); });
  }

  /* ------------------------------ görsel geri dönüşümü (bellek) ------------------------------ */
  // Yükledikçe kartlar birikiyor; iOS Safari yüzlerce kart görselinde sekmeyi bellekten çökertiyordu.
  // Ekrandan ~3 ekran uzaklaşan kart görseli boş GIF'e çevrilir, yaklaşınca geri konur (tarayıcı önbelleğinden gelir).
  // Görsel mutlak konumlu, kutu yüksekliği --aspect-ratio ile sabit → kayma olmaz.
  var BLANK_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7', imgIO = null;
  function recycleImgs() {
    if (!('IntersectionObserver' in window)) return;
    if (!imgIO) imgIO = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        e.target.querySelectorAll('img').forEach(function (im) {
          if (e.isIntersecting) {
            if (!im.hasAttribute('data-stk-src')) return;
            var ss = im.getAttribute('data-stk-srcset'); if (ss) im.setAttribute('srcset', ss);
            im.src = im.getAttribute('data-stk-src'); im.removeAttribute('data-stk-src'); im.removeAttribute('data-stk-srcset');
          } else if (!im.hasAttribute('data-stk-src') && im.complete && im.naturalWidth > 1) {
            im.setAttribute('data-stk-src', im.getAttribute('src') || ''); im.setAttribute('data-stk-srcset', im.getAttribute('srcset') || '');
            im.removeAttribute('srcset'); im.src = BLANK_GIF;
          }
        });
      });
    }, { rootMargin: '2500px 0px' });
    document.querySelectorAll('#product-grid .product-card__image:not([data-stk-rc])').forEach(function (a) { a.setAttribute('data-stk-rc', ''); imgIO.observe(a); });
  }

  /* ------------------------------ liste paylaş / geri yükle ------------------------------ */
  function shareUrl() {
    var code = S.items.map(function (it) { return it.h + ':' + it.vid + ':' + it.qty; }).join(',');
    return location.origin + location.pathname + '?stkpick=' + encodeURIComponent(code);
  }
  function shareList() {
    if (!S.items.length) return;
    var url = shareUrl(); track('stk_pick_share', { n: count() });
    if (navigator.share) { navigator.share({ title: t('share_title'), url: url }).catch(function () { /* iptal */ }); return; }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { toast(t('share_copied')); }, function () { window.prompt(t('share'), url); });
    else window.prompt(t('share'), url);
  }
  function restoreFromUrl() {
    var m = /[?&]stkpick=([^&]+)/.exec(location.search); if (!m) return;
    var parts = decodeURIComponent(m[1]).split(',').map(function (s) { var a = s.split(':'); return { h: a[0], vid: parseInt(a[1], 10), qty: Math.max(1, parseInt(a[2], 10) || 1) }; }).filter(function (x) { return x.h && x.vid; });
    var handles = []; parts.forEach(function (x) { if (handles.indexOf(x.h) < 0) handles.push(x.h); });
    Promise.all(handles.map(function (h) { return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        var byH = {}; ps.forEach(function (p) { if (p) byH[p.handle] = mapApiProduct(p); });
        var n = 0;
        parts.forEach(function (x) { var p = byH[x.h]; if (!p) return; var v = p.v.filter(function (vv) { return vv.id === x.vid && vv.a; })[0]; if (!v) return; S.products[p.id] = S.products[p.id] || p; addItem(p, v, x.qty, { silent: true, source: 'share' }); n += x.qty; });
        if (n) { toast(t('share_restored', { n: n })); setOpen(true); }
        try { var q = location.search.replace(/([?&])stkpick=[^&]*(&|$)/, '$1').replace(/[?&]$/, ''); history.replaceState(null, '', location.pathname + q + location.hash); } catch (e) { /* yoksay */ }
      });
  }

  /* ------------------------------ toast ------------------------------ */
  var toastEl = null, toastTimer = null;
  function toast(msg, err) {
    if (!toastEl) { toastEl = el('div', 'stk-pk-toast'); toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.toggle('is-err', !!err); toastEl.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ------------------------------ başlat ------------------------------ */
  load();
  scan(document);
  renderTray();
  fetchCart();
  if (S.open && S.items.length) loadRecs();
  restoreFromUrl();
  // Filtre/sıralama ile yeniden yüklenen kartlar (facets) ve sonradan eklenen kartlar
  var mo = new MutationObserver(function (muts) {
    var need = false;
    for (var i = 0; i < muts.length && !need; i++) {
      var add = muts[i].addedNodes;
      for (var j = 0; j < add.length; j++) { var nd = add[j]; if (nd.nodeType === 1 && (nd.matches('[data-stk-pick-data]') || nd.querySelector('[data-stk-pick-data]'))) { need = true; break; } }
    }
    if (need) scan(document);
  });
  mo.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { load(); paintCards(); renderTray(); paintMiniCount(); } });
  // Ürün sayfasındaki "Tepsiye ekle" (stickidy-pdp.js) localStorage'a yazıp bu olayı atar; aynı sekmede storage olayı gelmez
  document.addEventListener('stk:pick:sync', function () { S.items = []; load(); paintCards(); renderTray(); paintMiniCount(); if (count()) pulse(); });
  window.addEventListener('load', paintCards);
  // Sepet çekmecesinde adet/silme değişince (tema pub/sub) ve sekmeye geri dönünce sepeti tazele
  try { var EVS2 = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS; if (typeof window.subscribe === 'function' && EVS2 && EVS2.cartUpdate) window.subscribe(EVS2.cartUpdate, function () { setTimeout(fetchCart, 300); }); } catch (e) { /* yoksay */ }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) fetchCart(); });
  var rsz; window.addEventListener('resize', function () { clearTimeout(rsz); rsz = setTimeout(function () { paintCards(); if (count()) renderTray(); }, 150); });
  root.__stkPickApi = { state: S, addItem: addItem, scan: scan, deal: deal };
})();
